import type {
  IAvatarElement,
  IAvatarAccessory,
  IAvatarOptionsProps
} from '../../types';

import {
  getUserTooltip,
  getUserUnlockedElements
} from '@/redux/user/selectors';

import Store from '@/redux';
import { connect } from 'react-redux';
import ColorPanel from '../../ColorPanel';
import { useState, useMemo } from 'react';
import { getHex, getInt } from '@/utils/common';
import { setUserTooltip } from '@/redux/user/actions';
import { Container, Item } from './AccessoriesAvatar.styles';
import ColorTooltip from '@/components/AvatarOptionsPanel/ColorTooltip';
import ColorPalete from '@/assets/images/icons/color-palete.svg?component';

const AccessoriesAvatar = ({
  toggleColorPanel,
  unlockedElements,
  userTooltip,
  setOption,
  keysItem,
  option,
  label,
  list
}: IAvatarOptionsProps<IAvatarElement[]>) => {
  const [visibleColorPanel, setVisibleColorPanel] = useState(false);

  const setColor = (value: string) =>
    currentItem &&
    handleSetOption({
      ...currentItem,
      customColor: getInt(value)
    });

  const currentItem = useMemo(() => {
    const foundItem = option?.find((item) => {
      let key = item.name.toLowerCase().split('_')[0];

      if (key === 'x') key = item.name.toLowerCase().split('_')[1];
      if (typeof keysItem === 'string' && key === keysItem) return true;
      if (Array.isArray(keysItem)) return keysItem.find((item) => item === key);

      return false;
    });

    if (!foundItem) return;
    const detailsItem = list?.find((item) => item.name === foundItem.name);

    if (detailsItem)
      return {
        ...detailsItem,
        customColor: foundItem.color
      };

    return;
  }, [option, keysItem]);

  const colorPanelProps = useMemo(() => {
    if (!currentItem) return;

    const { customColor, colors } = currentItem;
    const color = typeof customColor === 'number' ? getHex(customColor) : '';

    const palettes = colors?.map((item) =>
      typeof item === 'string' ? item : getHex(item)
    );

    return {
      palettes,
      color
    };
  }, [currentItem]);

  const handleSetOption = (item: IAvatarAccessory) => {
    const newItem: IAvatarElement = { name: item.name };
    const elements = (option && [...option]) || [];

    if (item.customColor !== undefined) {
      newItem.color = item.customColor;
    } else if (item.colors?.[0]) {
      newItem.color = getInt(item.colors?.[0]);
    }

    if (currentItem) {
      const index = elements.findIndex(
        (item) => item.name === currentItem.name
      );

      if (index !== -1) elements.splice(index, 1);
    }

    elements.push(newItem);
    setOption('elements', elements);
  };

  const onCloseColorPanel = () => {
    setVisibleColorPanel(false);
    toggleColorPanel?.(false);
  };

  const onItemClick = (item: IAvatarAccessory, colorPicker: boolean) => {
    if (colorPicker && !visibleColorPanel) {
      !userTooltip && Store.dispatch(setUserTooltip(true));
      setVisibleColorPanel(true);
      return toggleColorPanel?.(true);
    }

    handleSetOption(item);
  };

  return (
    <>
      {visibleColorPanel ? (
        <ColorPanel
          onBack={onCloseColorPanel}
          {...colorPanelProps}
          setColor={setColor}
          label={label}
          popup
        />
      ) : (
        <Container className="accessories">
          {list?.map((item) => {
            const active = currentItem?.name === item.name;
            const colorPicker = active && item.colorPicker;

            const available =
              item.available || unlockedElements?.includes(item.id);

            return (
              available && (
                <Item
                  key={item.id}
                  isActive={active}
                  colorPicker={item.colorPicker}
                  onClick={() => onItemClick(item, colorPicker)}
                >
                  {item.icon}
                  {colorPicker && <ColorPalete />}
                  {colorPicker && !userTooltip && <ColorTooltip />}
                </Item>
              )
            );
          })}
        </Container>
      )}
    </>
  );
};

const mapStateToProps = (state: never) => ({
  unlockedElements: getUserUnlockedElements(state),
  userTooltip: getUserTooltip(state)
});

export default connect(mapStateToProps)(AccessoriesAvatar);
